import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeleteChatSessionPayload {
  chatSessionId: number | string;
}

interface DeleteChatSessionState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;  // store response message
}

const initialState: DeleteChatSessionState = {
  loading: false,
  error: null,
  success: false,
  message: null,
};

const deleteChatSessionSlice = createSlice({
  name: 'deleteChatSession',
  initialState,
  reducers: {
    deleteChatSessionRequest: (state, _action: PayloadAction<DeleteChatSessionPayload>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.message = null;
    },
    deleteChatSessionSuccess: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload; // store server detail
    },
    deleteChatSessionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetDeleteChatSession: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
});

export const { 
  deleteChatSessionRequest, 
  deleteChatSessionSuccess, 
  deleteChatSessionFailure,
  resetDeleteChatSession
} = deleteChatSessionSlice.actions;

export const deleteChatSessionReducer = deleteChatSessionSlice.reducer;
export const deleteChatSessionActionTypes = deleteChatSessionSlice.actions;
